import MaterialIcon from '@lib/components/MaterialIcon/MaterialIcon';
import Typography from '@lib/components/Typography/Typography';
import styles from './AiAssistant.module.scss';

type Props = {
  label: string;
  ariaLabel: string;
  onClick: () => void;
};

// A verified citation link after an inline document chip ("p. 3",
// "3:00–4:30"): opens the document at that place.
function CitationChip({ label, ariaLabel, onClick }: Props) {
  return (
    <button
      type="button"
      className={styles.citationPageChip}
      aria-label={ariaLabel}
      onClick={onClick}
    >
      <Typography variant="caption" component="span">
        {label}
      </Typography>
      <MaterialIcon
        icon="arrow_outward"
        symbolsOutlined
        size="md-16"
        className={styles.citationPageChipIcon}
      />
    </button>
  );
}

export default CitationChip;
